import { z } from 'zod';

export const viteEnvSchema = z.object({
  VITE_ENVIRONMENT: z.enum(['local', 'dev', 'qa', 'prod']),
  VITE_INTERNAL_API_BASE_URL: z.string().url(),
  VITE_SOCIAL_API_BASE_URL: z.string().url(),
  VITE_GOOGLE_CLIENT_ID: z.string(),
  VITE_MICROSOFT_CLIENT_ID: z.string(),
  VITE_SENTRY_DSN: z.string().url(),
  VITE_STRIPE_PUBLISHABLE_KEY: z.string(),
  VITE_PAYMENT_SERVER_URL: z.string().url(),
  VITE_AMPLITUDE_API_KEY: z.string(),
  VITE_PUBLIC_SMARTLOOK_API_KEY: z.string(),
  VITE_ENABLE_MSW: z.string().optional(), // MSW 모킹 활성화 여부 (optional, 'true'일 때만 활성화)
});

// Type-safe access to environment variables
export type ViteEnv = z.infer<typeof viteEnvSchema>;

export const isProd = import.meta.env.VITE_ENVIRONMENT === 'prod';
export const isDev = import.meta.env.VITE_ENVIRONMENT === 'dev';
export const isQa = import.meta.env.VITE_ENVIRONMENT === 'qa';
export const isLocal = import.meta.env.VITE_ENVIRONMENT === 'local';
